import { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import httpService from "V2.0/services/httpService";
import { formatTimestamp } from "../Threads/components/conversation_messages";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/components/DialogFullWidth";
import { RunPreviewer } from "./Builder/RunPreview";
import { ReactFlowProvider } from "@xyflow/react";
import { Button } from "V2.0/common/button";
import { PipelineRunStatus } from "./Runs/PipelineRunStatus";
import { TiFlowSwitch } from "react-icons/ti";
import { DialogTitleWithClose } from "V2.0/components/DialogTitleWithClose";
import { getPipelineRuns } from "./service";
import { showErrorToast } from "V2.0/utils";

export function WorkflowRuns(props) {
  const { workflow, projectId } = props;
  const [workflowRuns, setWorkflowRuns] = useState({
    isLoading: true,
    data: [],
  });
  const [open, setOpen] = useState({
    isOpen: false,
    workflowRun: null,
  });

  const fetchWorkflowRuns = async () => {
    try {
      const response = await getPipelineRuns({ workspaceId: projectId });
      const { pipelineRuns } = response.data;
      const filteredPipelineRuns = pipelineRuns.filter(
        (pipelineRun) => pipelineRun.pipeline === workflow._id
      );
      setWorkflowRuns({
        isLoading: false,
        data: filteredPipelineRuns,
      });
    } catch (e) {
      setWorkflowRuns((prevState) => {
        return {
          ...prevState,
          isLoading: false,
        };
      });
      showErrorToast(e, "Failed to get pipeline runs")
    }
  };

  useEffect(() => {
    if (projectId) {
      fetchWorkflowRuns();
    }
  }, [projectId, workflow]);

  if (workflowRuns.isLoading) {
    return null;
  }

  if (!workflowRuns.isLoading && workflowRuns.data.length === 0) {
    return (
      <div className="flex h-[40dvh] items-center justify-center mx-auto border rounded-lg">
        <div className="flex flex-col items-center">
          <TiFlowSwitch className="size-10 mr-1 text-gray-500" />
          <p className="font-medium text-md text-gray-500">No Pipeline runs</p>
        </div>
      </div>
    );
  }

  if (workflowRuns.data.length > 0) {
    return (
      <>
        <div className="h-[80dvh] overflow-scroll">
          <Table>
            <TableHead>
              <TableHeader>Phone Number</TableHeader>
              <TableHeader>Currently at</TableHeader>
              <TableHeader>Started At</TableHeader>
            </TableHead>
            <TableBody>
              {workflowRuns.data.map((run, idx) => {
                const {
                  userIdentifier,
                  currentNodeId,
                  nodeExecutions,
                  status,
                  startTime,
                } = run;

                const currentNode = nodeExecutions.find(
                  (node) => node.nodeId === currentNodeId
                );
                return (
                  <TableRow
                    onClick={() => setOpen({ isOpen: true, workflowRun: run })}
                  >
                    <TableCell>
                      <div className="flex flex-col gap-y-2">
                        <p className="font-semibold text-sm">
                          {userIdentifier}
                        </p>
                        <div>
                          <PipelineRunStatus status={status} />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>{currentNode?.settings?.name || ""}</TableCell>
                    <TableCell>{formatTimestamp(startTime)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
        {/* 
        {workflow && workflowRuns.length > 0 && (
          <div className="w-full h-full">
            <ReactFlowProvider>
              <RunPreviewer workflow={workflow} workflowRun={workflowRuns[0]} />
            </ReactFlowProvider>
          </div>
        )} */}

        {open.isOpen && (
          <Dialog
            size="full"
            className=""
            open={open.isOpen}
            onClose={() => setOpen({ isOpen: false, workflowRun: null })}
          >
            <DialogTitle className="p-4">
              <DialogTitleWithClose
                title="Pipeline Run"
                onClose={() => setOpen({ isOpen: false, workflowRun: null })}
              />
            </DialogTitle>
            <DialogBody>
              <div className="w-full h-[calc(100vh-80px)] relative border rounded-b-xl">
                <ReactFlowProvider>
                  <RunPreviewer
                    workflow={workflow}
                    workflowRun={open.workflowRun}
                  />
                </ReactFlowProvider>
              </div>
            </DialogBody>
            {/* <DialogActions>
              <Button outline onClick={() => setOpen({ isOpen: false })}>Close</Button>
            </DialogActions> */}
          </Dialog>
        )}
      </>
    );
  }
}
